import { createFileRoute } from "@tanstack/react-router"

import { ReportingDashboard } from "@/features/reporting/reporting-dashboard"

/**
 * The reporting route.
 *
 * A thin wrapper: the screen itself lives in features/reporting so it can be
 * rendered — and tested — without a router around it.
 */
export const Route = createFileRoute("/_panel/reporting")({
	component: ReportingDashboard,
})
